export const CACHE_TIME = 1000 * 60 * 5; // 5 minutes
export const STALE_TIME = 1000 * 20; // don't consider the data stale until 20 seconds based on https://fwuensche.medium.com/react-query-cachetime-vs-staletime-ec74defc483e
export const TEACHING_DELIVERY_ROW_HEADERS = ['Taught weeks', 'Classes', 'Duration'];
export const FILTERS = {
  SCHOOL: 'school' as const,
  DISCIPLINE: 'discipline' as const,
  STUDYPERIOD: 'studyPeriod' as const,
  EMPSTATUSABBR: 'empStatusAbbr' as const,
  YEAR: 'year' as const,
};
export const UC_ALLOCATION_METHOD = {
  PLANNED_ENROLMENT_CALCULATION: 'PLANNED_ENROLMENT_CALCULATION' as const,
  RANGE_ALLOCATION: 'RANGE_ALLOCATION' as const,
};
export const DEFAULT_LEAVE_HOURS = 150;
export const MAX_ALLOCATABLE_HOURS = 1875;
